import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Popup from 'reactjs-popup'

const Collapse = styled.div.attrs({
    className: 'collpase navbar-collapse',
})``

const List = styled.div.attrs({
    className: 'navbar-nav mr-auto',
})``

const Item = styled.div.attrs({
    className: 'collpase navbar-collapse',
})``

const Right = styled.div.attrs({
    className: 'navbar-nav navbar-right',
})``

function Links(props) {
    return (
        <React.Fragment>
            <Link to="/" className="navbar-brand">
                Histoire des pratiques litt&eacute;raires num&eacute;riques au Qu&eacute;bec
             </Link>
             <Collapse>
                 {props.isLoggedIn ?
                     <List>
                        <Item>
                            <Link to="/oeuvres/list" className="nav-link">
                                Liste des &oelig;uvres
                            </Link>
                        </Item>
                        <Item>
                            <Link to="/oeuvres/create" className="nav-link">
                                Ajouter une &oelig;uvre
                            </Link>
                        </Item>
                      </List>
                  : <List></List>}
                  <Right>
                      <Item>
                          {!props.isLoggedIn ?
                            <Popup trigger={<button className="btn btn-link nav-link">Connexion</button>} position="bottom center">
                              <form style={{padding: '1em'}} onSubmit={(e) => { e.preventDefault(); props.doLogin();}}>
                                <div className="form-group">
                                  <input type="text" className="form-control" id="loginUserName" placeholder="Nom d'utilisateur" />
                                </div>
                                <div className="form-group">
                                  <input type="password" className="form-control" id="loginPassword" placeholder="Mot de passe" />
                                </div>
                                <button type="submit" className="btn btn-dark">Se connecter</button>
                              </form>
                            </Popup>
                          : <button className="btn btn-link nav-link" onClick={() => props.doLogout()}>Se déconnecter</button>}
                        </Item>
                  </Right>
              </Collapse>
        </React.Fragment>
    )
}

export default Links
